import debounce from '../util/debounce';
import {register} from '../vendor/theme-scripts/theme-sections';
import removeAnimations from '../features/remove-animations';
import {ajaxify} from '../features/infinity-scroll';

const sections = {};

const selectors = {
  blogPost: '[data-blog-post]',
};

class Blog {
  constructor(section) {
    this.container = section.container;
    this.resizeEvent = debounce(() => this.checkWindowWidth(), 200);

    this.init();
  }

  init() {
    this.checkWindowWidth();

    window.addEventListener('resize', this.resizeEvent);
  }

  checkWindowWidth() {
    const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    if (windowWidth <= theme.sizes.small) {
      removeAnimations(this.container);
    }
  }

  onUnload() {
    window.removeEventListener('resize', this.resizeEvent);
  }
}

const BlogSection = {
  onLoad() {
    sections[this.id] = new Blog(this);
  },
  onUnload(e) {
    sections[this.id].onUnload(e);
  },
};

register('blog', [BlogSection, ajaxify]);
register('featured-blog', BlogSection);
